import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedModule } from '@/shared.module';

/**
 * Teacher-only "registered on/by" override fields of a concept careplan-NNN
 * registration. Purely presentational: emits the edited date/time/user and
 * leaves persisting to the parent.
 */
@Component({
  selector: 'app-nnn-view-user-fields',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './nnn-view-user-fields.component.html',
  styleUrl: './nnn-view-user-fields.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NnnViewUserFieldsComponent {
  readonly date = input<Date | null>(null);
  readonly time = input('');
  readonly user = input('');

  readonly dateChange = output<Date | null>();
  readonly timeChange = output<string>();
  readonly userChange = output<string>();

  protected onTimeFocusOut(event: Event): void {
    this.timeChange.emit((event.target as HTMLInputElement).value);
  }

  protected onUserFocusOut(event: Event): void {
    this.userChange.emit((event.target as HTMLInputElement).value);
  }
}
